// src/pages/pentest/darkweb/nav.jsx
import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { useNavigate, useLocation } from 'react-router-dom';

// Icons
import DashboardIcon from '@mui/icons-material/Dashboard';
import FindInPageIcon from '@mui/icons-material/FindInPage';
import DescriptionIcon from '@mui/icons-material/Description';
import AssessmentIcon from '@mui/icons-material/Assessment';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

function Nav() {
  const navigate = useNavigate();
  const location = useLocation();

  // Extract pentest_id as last segment (safer than hard index)
  const pathParts = location.pathname.replace(/\/$/, '').split('/').filter(Boolean);
  const pentest_id = pathParts[pathParts.length - 1];

  /**
   * Tab indexes:
   * 0 = Dashboard
   * 1 = Findings
   * 2 = Reports (dropdown)
   */
  const [selectedTab, setSelectedTab] = useState(0);
  const [reportAnchorEl, setReportAnchorEl] = useState(null);

  useEffect(() => {
    const path = location.pathname;

    if (/^\/pentest\/darkweb\/dashboard\/\d+$/.test(path)) {
      setSelectedTab(0);
    } else if (/^\/pentest\/darkweb\/findings\/\d+$/.test(path)) {
      setSelectedTab(1);
    } else if (/^\/pentest\/darkweb\/report\/(pentest|executive|attestation)\/\d+$/.test(path)) {
      setSelectedTab(2);
    } else {
      setSelectedTab(0);
    }
  }, [location.pathname]);

  // Skip dropdown tab (2)
  const handleTabChange = (_event, newValue) => {
    if (newValue === 2) return;

    setSelectedTab(newValue);

    switch (newValue) {
      case 0:
        navigate(`/pentest/darkweb/dashboard/${pentest_id}`);
        break;
      case 1:
        navigate(`/pentest/darkweb/findings/${pentest_id}`);
        break;
      default:
        break;
    }
  };

  // Reports dropdown handlers
  const handleReportClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setReportAnchorEl(e.currentTarget);
  };
  const handleReportClose = () => setReportAnchorEl(null);
  const handleReportItem = (type) => {
    setReportAnchorEl(null);
    setSelectedTab(2);
    // ✅ Dark web reports live under the Reports dropdown now
    navigate(`/pentest/darkweb/report/${type}/${pentest_id}`);
  };

  return (
    <Box
      sx={{
        backgroundColor: 'white',
        padding: '10px',
        borderRadius: '10px',
        boxShadow: 'rgba(0, 0, 0, 0.1) 0px 4px 12px',
        marginBottom: '20px',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: '10px',
        }}
      >
        <Typography variant="h4" sx={{ fontWeight: 'bold' }}>
          Dark Web
        </Typography>
      </Box>

      <Tabs
        value={selectedTab}
        onChange={handleTabChange}
        aria-label="Dark Web Navigation Tabs"
        textColor="primary"
        indicatorColor="primary"
      >
        <Tab icon={<DashboardIcon />} label="Dashboard" />
        <Tab icon={<FindInPageIcon />} label="Findings" />

        {/* Reports dropdown */}
        <Tab
          icon={<DescriptionIcon />}
          label={
            <div style={{ display: 'flex', alignItems: 'center' }}>
              Reports <ArrowDropDownIcon fontSize="small" />
            </div>
          }
          onClick={handleReportClick}
        />
      </Tabs>

      {/* Reports Menu */}
      <Menu anchorEl={reportAnchorEl} open={Boolean(reportAnchorEl)} onClose={handleReportClose}>
        <MenuItem onClick={() => handleReportItem('pentest')}>
          <DescriptionIcon style={{ marginRight: 8 }} /> Pentest Report
        </MenuItem>
        <MenuItem onClick={() => handleReportItem('executive')}>
          <AssessmentIcon style={{ marginRight: 8 }} /> Executive Summary
        </MenuItem>
        <MenuItem onClick={() => handleReportItem('attestation')}>
          <EmojiEventsIcon style={{ marginRight: 8 }} /> Attestation
        </MenuItem>
      </Menu>
    </Box>
  );
}

export default Nav;
